import { render, staticRenderFns } from "./buyQuestModal.vue?vue&type=template&id=0efd9cd8&"
import script from "./buyQuestModal.vue?vue&type=script&lang=js&"
export * from "./buyQuestModal.vue?vue&type=script&lang=js&"
import style0 from "./buyQuestModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports